import React from 'react';
import StyledEventText from './StyledEventText';
import { EventMessageProps } from './EventMessageProps';

const EventText: React.FC<EventMessageProps> = ({ message }) => {
  if (message) {
    return <StyledEventText>{message}</StyledEventText>;
  }

  return null;
};

export default EventText;
